import { cn } from '@/lib/utils';
import { ButtonSpinner } from '@/shared/components/button-spinner';

interface OfferStickyCtaProps {
  label: string;
  onClick: () => void;
  purchasing?: boolean;
  hidden: boolean;
  muted?: boolean;
}

/**
 * CTA pinned to the bottom over a fade, hidden while an inline `[data-offer-cta]`
 * button is in view.
 */
export function OfferStickyCta({
  label,
  onClick,
  purchasing = false,
  hidden,
  muted = false,
}: OfferStickyCtaProps) {
  return (
    <div
      aria-hidden={hidden}
      className={cn(
        'pointer-events-none fixed inset-x-0 bottom-0 z-40 flex w-full flex-col items-center bg-mf-neutral-50 px-4 pb-[max(1.25rem,env(safe-area-inset-bottom))] pt-10',
        // `opacity-0` is still sampled by iOS 26 Safari. Hide from the render tree.
        hidden && 'hidden',
      )}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent to-mf-neutral-50"
      />
      <button
        type="button"
        onClick={onClick}
        disabled={purchasing || hidden}
        className={cn(
          'relative z-10 mx-auto flex h-[52px] w-full max-w-[361px] items-center justify-center gap-1 rounded-full px-5 font-body text-base font-bold leading-5 text-white transition-opacity hover:opacity-90 disabled:opacity-50',
          hidden ? 'pointer-events-none' : 'pointer-events-auto',
          muted ? 'bg-mf-neutral-900/20 backdrop-blur-[10px]' : 'bg-mf-green',
        )}
      >
        {purchasing ? <ButtonSpinner /> : label}
      </button>
    </div>
  );
}
